<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'AdminCompanies',
  }
</script>

<style scoped>
</style>
